import React, { FC } from 'react'

import type { ButtonProps } from '../../Button'
import { Button } from '../../Button'
import { SetStepCursor, StepCount, StepCursor } from '../../FullScreenStepper/FullScreenStepperProps'
import { augmentButtonProps } from './augmentButtonProps'

export const StepperActionsNextButton: FC<{
  handleNextClick: () => Promise<void>
  nextButtonProps?: ButtonProps
  setStepCursor: SetStepCursor
  stepCursor: StepCursor
  stepCount: StepCount
  finishButtonText?: string
  nextButtonText?: string
}> = (props) => {
  const { handleNextClick, nextButtonProps, setStepCursor, stepCursor, stepCount, finishButtonText, nextButtonText } =
    props
  const augmentedNextButtonProps = augmentButtonProps(
    { onClick: handleNextClick },
    nextButtonProps,
    setStepCursor,
    stepCursor,
    1,
  )
  const finalStep = stepCursor / stepCount === 1
  const finishText = finishButtonText || 'finish'
  const nextText = nextButtonText || 'next'
  const buttonText = finalStep ? finishText : nextText

  return <Button {...augmentedNextButtonProps}>{buttonText}</Button>
}
